// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Boolean
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.autopay.Biller
import org.mifospay.core.model.autopay.BillerCategory

@OptIn(InternalKtorfitApi::class)
public class _BillerServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : BillerService {
  override fun getAllBillers(): Flow<List<Biller>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "billers")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<Biller>>>(),)!! 
  }

  override suspend fun getBillerById(billerId: String): Flow<Biller> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "billers/${"$billerId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Biller>>(),)!! 
  }

  override suspend fun createBiller(biller: Biller): Flow<Biller> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "billers")
        }
        setBody(biller) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Biller>>(),)!! 
  }

  override suspend fun updateBiller(billerId: String, biller: Biller): Flow<Biller> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "billers/${"$billerId".encodeURLPath()}")
        }
        setBody(biller) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Biller>>(),)!! 
  }

  override suspend fun deleteBiller(billerId: String): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "billers/${"$billerId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }

  override suspend fun getBillersByCategory(category: BillerCategory): Flow<List<Biller>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "billers/category/${"$category".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Biller>>>(),)!! 
  }

  override suspend fun searchBillersByName(query: String): Flow<List<Biller>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "billers/search")
        query?.let{ parameter("query", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<Biller>>>(),)!! 
  }

  override suspend fun isBillerExists(name: String, accountNumber: String): Flow<Boolean> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "billers/exists")
        name?.let{ parameter("name", "$it") }
        accountNumber?.let{ parameter("accountNumber", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Boolean>>(),)!! 
  }

  override suspend fun clearAllBillers(): Flow<Unit> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "billers")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Unit>>(),)!! 
  }
}

public class _BillerServiceProvider : ClassProvider<BillerService> {
  override fun create(_ktorfit: Ktorfit): BillerService = _BillerServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createBillerService(): BillerService = _BillerServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
